import { render, staticRenderFns } from "./Opportunities.vue?vue&type=template&id=b2e54368&scoped=true"
import script from "./Opportunities.vue?vue&type=script&lang=js"
export * from "./Opportunities.vue?vue&type=script&lang=js"
import style0 from "./Opportunities.vue?vue&type=style&index=0&id=b2e54368&lang=scss&scoped=true"
import style1 from "./Opportunities.vue?vue&type=style&index=1&id=b2e54368&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e54368",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2e54368')) {
      api.createRecord('b2e54368', component.options)
    } else {
      api.reload('b2e54368', component.options)
    }
    module.hot.accept("./Opportunities.vue?vue&type=template&id=b2e54368&scoped=true", function () {
      api.rerender('b2e54368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Search/Tabs/Opportunities.vue"
export default component.exports